const t = ["overlay", "popover", "menu", "tooltip", "toast"], e = (o) => `var(--layer-${o})`;
export {
  t as LAYERS,
  e as layer
};
